import { StorageRootDto } from "../StorageRootDto";
import { UpdateResultDto } from "../UpdateResultDto";
import { Privileges } from "../Auth/Privileges";


export class ShareTypes {

	public static readonly Network: string = "network";
}


export class ShareAccessTypes {
	public static readonly None: string = "none";
	public static readonly View: string = "view";
	public static readonly Edit: string = "edit";
}


export class ShareDto extends StorageRootDto {

	public ShareType: string;
	public SourceUserGuid: string;
	public SourceUserName: string;
	public TargetUserGuid: string;
	public TargetUserName: string;
	public TargetGroupGuid: string;
	public TargetGroupName: string;
	public SharedItemGuid: string;
	public AccessType: string;
	public Privileges: Privileges;

	constructor() {
		super();

		this.Clear();
	}

	public Clear(): void {
		this.ShareType = "";
		this.SourceUserGuid = "";
		this.SourceUserName = "";
		this.TargetUserGuid = "";
		this.TargetUserName = "";
		this.TargetGroupGuid = "";
		this.TargetGroupName = "";
		this.SharedItemGuid = "";
		this.AccessType = "";
		this.Privileges = new Privileges();
	}

	public get HasShareType(): boolean {
		return !!this.ShareType;
	}

	public get HasSourceUserGuid(): boolean {
		return !!this.SourceUserGuid;
	}

	public get HasSourceUserName(): boolean {
		return !!this.SourceUserName;
	}

	public get HasTargetUserGuid(): boolean {
		return !!this.TargetUserGuid;
	}

	public get HasTargetUserName(): boolean {
		return !!this.TargetUserName;
	}

	public get HasTargetGroupGuid(): boolean {
		return !!this.TargetGroupGuid;
	}

	public get HasTargetGroupName(): boolean {
		return !!this.TargetGroupName;
	}

	public get HasSharedItemGuid(): boolean {
		return !!this.SharedItemGuid;
	}

	public get HasAccessType(): boolean {
		return !!this.AccessType;
	}

	public get HasPrivileges(): boolean {
		return (!!this.Privileges && this.Privileges.HasEntries);
	}

	public CopyProps(obj: UpdateResultDto, isCreate: boolean = true) {
		super.CopyProps(obj, isCreate);

		this.SourceUserGuid = obj.SourceUserGuid;
		this.SourceUserName = obj.SourceUserName;
		this.TargetUserGuid = obj.TargetUserGuid;
		this.TargetUserName = obj.TargetUserName;
		this.TargetGroupGuid = obj.TargetGroupGuid;
		this.TargetGroupName = obj.TargetGroupName;
	}

	public Write(obj: any, context: any): void {
		obj.share = {};
		obj = obj.share;

		super.Write(obj, context);

		if (this.HasShareType) {
			obj.share_type = this.ShareType;
		}
		if (this.HasSourceUserGuid) {
			obj.source_user_guid = this.SourceUserGuid;
		}
		if (this.HasSourceUserName) {
			obj.source_user_name = this.SourceUserName;
		}
		if (this.HasTargetUserGuid) {
			obj.target_user_guid = this.TargetUserGuid;
		}
		if (this.HasTargetUserName) {
			obj.target_user_name = this.TargetUserName;
		}
		if (this.HasTargetGroupGuid) {
			obj.target_group_guid = this.TargetGroupGuid;
		}
		if (this.HasTargetGroupName) {
			obj.target_group_name = this.TargetGroupName;
		}
		if (this.HasSharedItemGuid) {
			obj.shared_item_guid = this.SharedItemGuid;
		}
		if (this.HasAccessType) {
			obj.access_type = this.AccessType;
		}
		if (this.HasPrivileges) {
			this.Privileges.Write(obj, context);
		}
	}

	public Read(obj: any, context: any): void {
		if (!obj.share)
			throw new Error();
		obj = obj.share;

		super.Read(obj, context);

		if (obj.share_type !== undefined) {
			this.ShareType = obj.share_type;
		}
		if (obj.source_user_guid !== undefined) {
			this.SourceUserGuid = obj.source_user_guid;
		}
		if (obj.source_user_name !== undefined) {
			this.SourceUserName = obj.source_user_name;
		}
		if (obj.target_user_guid !== undefined) {
			this.TargetUserGuid = obj.target_user_guid;
		}
		if (obj.target_user_name !== undefined) {
			this.TargetUserName = obj.target_user_name;
		}
		if (obj.target_group_guid !== undefined) {
			this.TargetGroupGuid = obj.target_group_guid;
		}
		if (obj.target_group_name !== undefined) {
			this.TargetGroupName = obj.target_group_name;
		}
		if (obj.shared_item_guid !== undefined) {
			this.SharedItemGuid = obj.shared_item_guid;
		}
		if (obj.access_type !== undefined) {
			this.AccessType = obj.access_type;
		}
		if (obj.privileges !== undefined) {
			this.Privileges.Read(obj, context);
		}
	}

}
